var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress-bar-inner blue lighten-2",style:({ width: _vm.progress + '%' })})])}
var staticRenderFns = []

export { render, staticRenderFns }